export enum InterpretingSessionType {
  NORMAL = 'Normal', // A normal interpreting session where SignMail is not involved
  SIGN_MAIL_GREETING = 'SignMailGreeting', // An interpreting session where a SignMail greeting was being interpreted
  HEARING_TO_DEAF_MESSAGE = 'HearingToDeafMessage', // An interpreting session where a hearing to deaf message is being recorded
  ANSWERING_MACHINE = 'AnsweringMachine', // An interpreting session where CaptionCall is interpreting an answering machine
}
